import { render, staticRenderFns } from "./SingleThreewaySwitchWidget.vue?vue&type=template&id=a5aff988&scoped=true"
import script from "./SingleThreewaySwitchWidget.vue?vue&type=script&lang=js"
export * from "./SingleThreewaySwitchWidget.vue?vue&type=script&lang=js"
import style0 from "./SingleThreewaySwitchWidget.vue?vue&type=style&index=0&id=a5aff988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aff988",
  null
  
)

export default component.exports